import { FormattedNumber, useIntl } from 'react-intl';
import { Card } from '../Card';

const numberFormatOptions = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const PriceSection = () => {
  const intl = useIntl();
  const _ = (id, values) => intl.formatMessage({ id: id }, values);

  const price = 20;

  return (
    <>
      <div className="col-sm-6">
        <div>
          <span className="dp-legend-price">
            {_(`my_plan.addons.conversations.plans_from_legend`)}
          </span>
          <h2>
            US$ <FormattedNumber value={price} {...numberFormatOptions} />*
          </h2>
          <span className="dp-disclaimer">{_(`my_plan.addons.conversations.month_legend`)}</span>
        </div>
      </div>
    </>
  );
};

export const Conversations = ({ conversation }) => {
  const intl = useIntl();
  const _ = (id, values) => intl.formatMessage({ id: id }, values);

  var hasConversations = conversation.plan?.active;

  return (
    <Card
      title={_(`my_plan.addons.conversations.title`)}
      icon={'iconapp-chatting'}
      description={_(`my_plan.addons.conversations.description`)}
      priceSection={<PriceSection></PriceSection>}
      moreInformationText={_(`my_plan.addons.more_information_link`)}
      moreInformationLink={_(`my_plan.addons.conversations.more_information_link`)}
      buyButtonText={_(
        `${
          hasConversations
            ? 'my_plan.addons.change_plan_button'
            : conversation.active
              ? 'my_plan.addons.buy_button'
              : 'my_plan.addons.activate_now_button'
        }`,
      )}
      buyButtonUrl={conversation.plan.buttonUrl}
    ></Card>
  );
};
